import { render, staticRenderFns } from "./MegaMenuLevelTwoMobile.vue?vue&type=template&id=589a2206&scoped=true&"
import script from "./MegaMenuLevelTwoMobile.vue?vue&type=script&lang=js&"
export * from "./MegaMenuLevelTwoMobile.vue?vue&type=script&lang=js&"
import style0 from "./MegaMenuLevelTwoMobile.vue?vue&type=style&index=0&id=589a2206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a2206",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsChevronLeft16px: require('/var/www/packages/theme/components/icons/chevron-left/ChevronLeft16px.vue').default,IconsChevronRight16px: require('/var/www/packages/theme/components/icons/chevron-right/ChevronRight16px.vue').default,AtomsThumbnail: require('/var/www/packages/theme/components/atoms/Thumbnail.vue').default})
